"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("@babel/polyfill");

var _hlsController = _interopRequireDefault(require("./hls-controller"));

var _mseController = _interopRequireDefault(require("./mse-controller"));

var _muxer = _interopRequireDefault(require("./muxer"));

var _manson = _interopRequireDefault(require("@krad/manson"));

var _support = _interopRequireDefault(require("./support"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StreamController =
/*#__PURE__*/
function () {
  function StreamController(config) {
    _classCallCheck(this, StreamController);

    this.hls = new _hlsController.default(config);
    this.muxer = new _muxer.default();
    this.segmentDownloaded = this.segmentDownloaded.bind(this);
    this.process = this.process.bind(this);
    this.hls.segmentFetchedCallback = this.segmentDownloaded;

    this.segmentConsumedCB = function () {};

    this.segments = [];
    this.processing = false;
  }

  _createClass(StreamController, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(video) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _manson.default.info('starting stream...');

                if (!_support.default.hasNativeHLSSupportFor(video)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.startNative(video));

              case 5:
                return _context.abrupt("return", this.startPlainview(video));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function start(_x) {
        return _start.apply(this, arguments);
      };
    }()
  }, {
    key: "startNative",
    value: function () {
      var _startNative = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(video) {
        var _this = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _manson.default.debug('browser has native HLS support.  delegating responsibilities');

                return _context2.abrupt("return", new Promise(function (resolve, _) {
                  video.src = _this.hls.url;
                  resolve();
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function startNative(_x2) {
        return _startNative.apply(this, arguments);
      };
    }()
  }, {
    key: "startPlainview",
    value: function () {
      var _startPlainview = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(video) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _manson.default.debug('browser does not have native HLS support.  assuming responsibilities');

                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  _this2.hls.configure().then(function (_) {
                    _this2.mse = new _mseController.default(_this2.hls.codecsString);
                    return _this2.mse.setVideo(video);
                  }).then(function (_) {
                    return _this2.hls.start();
                  }).catch(function (err) {
                    reject(err);
                  });
                }));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function startPlainview(_x3) {
        return _startPlainview.apply(this, arguments);
      };
    }()
  }, {
    key: "segmentDownloaded",
    value: function segmentDownloaded(segment) {
      this.segments.push(segment);
      this.process();
    }
  }, {
    key: "process",
    value: function () {
      var _process = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var segment, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _segment;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.processing) {
                  _context4.next = 40;
                  break;
                }

                this.processing = true;
                segment = this.segments.shift();

                if (!(this.hls.segmentsType === 'ts')) {
                  _context4.next = 35;
                  break;
                }

                _context4.next = 6;
                return this.muxer.transcode(segment);

              case 6:
                res = _context4.sent;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 10;
                _iterator = res[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 19;
                  break;
                }

                _segment = _step.value;
                _context4.next = 16;
                return this.mse.appendBuffer(_segment);

              case 16:
                _iteratorNormalCompletion = true;
                _context4.next = 12;
                break;

              case 19:
                _context4.next = 25;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context4.t0;

              case 25:
                _context4.prev = 25;
                _context4.prev = 26;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 28:
                _context4.prev = 28;

                if (!_didIteratorError) {
                  _context4.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context4.finish(28);

              case 32:
                return _context4.finish(25);

              case 33:
                _context4.next = 37;
                break;

              case 35:
                _context4.next = 37;
                return this.mse.appendBuffer(segment);

              case 37:
                this.segmentConsumedCB();
                this.processing = false;

                if (this.segments.length > 0) {
                  this.process();
                }

              case 40:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[10, 21, 25, 33], [26,, 28, 32]]);
      }));

      return function process() {
        return _process.apply(this, arguments);
      };
    }()
  }, {
    key: "totalDuration",
    get: function get() {
      if (this.hls && this.hls.playlist) {
        return this.hls.playlist.totalDuration;
      }
    }
  }, {
    key: "onDownloadProgress",
    set: function set(cb) {
      if (this.hls) {
        this.hls.onDownloadProgress = cb;
      }
    }
  }]);

  return StreamController;
}();

var _default = StreamController;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/distribution/stream-controller.js
// module id = 445
// module chunks = 0